module.exports = __webpack_public_path__ + "media/images/icons/list-item-bullet-dcb1a13cd8b4a24e6e87f1cee120af16.svg";